import { Box, Button, Stack, Typography } from '@mui/material'
import { ArrowBack, OpenInNew } from '@mui/icons-material'
import { IsdDistrictProgramEnhancementsList } from './IsdDistrictProgramEnhancementsList'

interface Props {
  priorityId: number
  planOrgId: number
  isdOrgId: number
  readOnly: boolean
  trackingReadonly: boolean
  onBack: () => void
  implementationPhase?: boolean
  handleViewContract?: () => void
}

export const IsdDistrictProgramEnhancements = (props: Props): JSX.Element => {
  return <Box data-testid='isdDistrictProgramEnhancements' sx={{
    display: 'flex',
    flexDirection: 'column',
    gap: '20px'
  }}
  >
    <Stack direction='row' justifyContent='space-between' alignItems='center'>
      <Button
        data-testid="backPdrsButton"
        onClick={props.onBack}
        sx={{
          padding: '5px 10px',
          backgroundColor: 'var(--grey-50)',
          color: 'var(--grey-500)',
          width: 'fit-content'
        }}
      >
        <ArrowBack sx={{ mr: '10px' }} />
        Peer to Peer Programs
      </Button>
      {props.implementationPhase === true && (
        <Button
          data-testid="viewContractButton"
          sx={{
            padding: '5px 10px',
            backgroundColor: 'var(--grey-50)',
            color: 'var(--grey-500)',
            width: 'fit-content',
            textTransform: 'none'
          }}
          onClick={props.handleViewContract}
        >
          View Contract
          <OpenInNew fontSize='small' sx={{ ml: '10px' }} />
        </Button>
      )}
    </Stack>

    <Typography variant='h1'>ISD/District Program Enhancements</Typography>
    <Typography variant='body1'>
      Peer to Peer program enhancement activities build upon existing programs to strengthen the program through partnerships, community engagement, use of additional resource tools, and participation in Peer to Peer beyond school hours. For program enhancements, list the contact information for the Program Enhancement Plan, actions planned, resources needed, and the budget request. Click “Things to Consider” for additional information.
    </Typography>

    <IsdDistrictProgramEnhancementsList
      priorityId={props.priorityId}
      planOrgId={props.planOrgId}
      isdOrgId={props.isdOrgId}
      readOnly={props.readOnly}
      trackingReadonly={props.trackingReadonly}
      implementationPhase={props.implementationPhase}
    />
  </Box>
}
